exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".transfer-apply-dialog .el-dialog .el-dialog__body {\n  padding: 30px;\n}\n.transfer-apply-dialog .el-dialog .el-form-item {\n  margin-bottom: 20px;\n}\n.transfer-apply-dialog .el-dialog .el-form-item__content {\n  line-height: normal;\n}\n.transfer-apply-dialog label.el-form-item__label {\n  font-size: 14px;\n  color: #555555;\n  letter-spacing: 0;\n}\n.transfer-apply-dialog .el-select {\n  width: 100%;\n}", ""]);
// Exports
exports.locals = {
	"theme": "#00b3ee",
	"menuBg": "#1f2d52",
	"minWidth": "1190",
	"minHeight": "669.375",
	"headerHeight": "60",
	"footerHeight": "60",
	"menuText": "#dae3f2",
	"menuActiveText": "#fff",
	"subMenuActiveText": "#00b3ee",
	"sidebarWidth": "200",
	"treeWidth": "340",
	"crumbsHeight": "60"
};